import { useQuery } from '@tanstack/react-query';
import { ProductSearchResult } from '@upright/common/model/input/blanket/blanket-product/api-types';
import { fetchOrThrow } from '@upright/ui/api/common/fetchers/fetch-or-throw';

export function useSearchUpgTaxonomy(query: string, enabled: boolean) {
  return useQuery({
    queryKey: ['search-upg-taxonomy', query],
    queryFn: async () => {
      return await fetchOrThrow<ProductSearchResult[]>(
        `/search/upg-taxonomy?query=${encodeURIComponent(query)}&limit=20`,
      );
    },
    enabled: enabled && query.length >= 2,
    staleTime: 30000, // 30 seconds
  });
}
